import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'Null2BarFilter'})
export class Null2BarFilter implements PipeTransform {
  transform(value:any): any {
    return (value === undefined || ('' + value).trim() === '' || value === null ) ? '―' : value;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/pipes/null2bar.pipe.ts